import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { addDisplayName } from "../Infra/display-name";
import { SmartAuthError, SmartAuthProgress, SmartAuthProgressViewParent, SmartAuthSpinnerHolder } from "./SmartAuthProgressView.styles";
import { SmartAuthProgressViewModel } from "./SmartAuthProgressViewModel";
import { spinner } from "./Spinner";
import { useViewModel } from "./useViewModel";
export const SmartAuthProgressView = observer((props) => {
    const model = useViewModel(SmartAuthProgressViewModel, props.container);
    return (_jsx(SmartAuthProgressViewParent, { children: model.error ? (_jsxs(SmartAuthError, { children: ["An error occurred while logging you in: ", model.error] })) : (_jsxs(_Fragment, { children: [_jsx(SmartAuthProgress, { children: "Loading... " }), model.showSpinner && _jsx(SmartAuthSpinnerHolder, { children: spinner() })] })) }));
});
addDisplayName(SmartAuthProgressView, "SmartAuthProgressView");
